import { createContext, useContext } from 'react';
import type { SubscriptionTier } from '../../../../enums/clientEnums';

// The stepper hands each step only its navigation callback, so wizard-wide
// values reach the steps through here rather than through step props.
export interface ClientFormMeta {
  isEditing: boolean;
  /** The saved subscription's tier; it floors the tier options, which never downgrade. */
  currentTier?: SubscriptionTier;
  /** The saved subscription's expiry; it is what the CURRENT term resolves to. */
  currentExpiry?: string | null;
}

export const ClientFormMetaContext = createContext<ClientFormMeta>({ isEditing: false });

export const useClientFormMeta = () => useContext(ClientFormMetaContext);
